/* tslint:disable */
/* eslint-disable */
/**
 * Bill Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AddBillRequest } from '../model';
// @ts-ignore
import { AddBillResponse } from '../model';
// @ts-ignore
import { AddBillSuggestedServiceRequest } from '../model';
// @ts-ignore
import { AddCommentRequest } from '../model';
// @ts-ignore
import { AdminBillResponse } from '../model';
// @ts-ignore
import { AdminTicketResponse } from '../model';
// @ts-ignore
import { AllCityMappingsResponse } from '../model';
// @ts-ignore
import { AllProvidersBillAnalyticsResult } from '../model';
// @ts-ignore
import { AnalyticProviders } from '../model';
// @ts-ignore
import { BillAnalyticsResult } from '../model';
// @ts-ignore
import { BillAssociationRequest } from '../model';
// @ts-ignore
import { BillCancelBeforeReserveRequest } from '../model';
// @ts-ignore
import { BillListResponse } from '../model';
// @ts-ignore
import { BillResponse } from '../model';
// @ts-ignore
import { BillResponseSummary } from '../model';
// @ts-ignore
import { BillRevenueResponse } from '../model';
// @ts-ignore
import { BillStatus } from '../model';
// @ts-ignore
import { BillUnSuccessfulBuyReserveRequest } from '../model';
// @ts-ignore
import { ChangeTripReasonRequest } from '../model';
// @ts-ignore
import { EditBillSuggestedService } from '../model';
// @ts-ignore
import { EditPersonRequest } from '../model';
// @ts-ignore
import { FullRefundResponse } from '../model';
// @ts-ignore
import { GetBillMobileResponse } from '../model';
// @ts-ignore
import { RecentBillIdsOfPassengersResponse } from '../model';
// @ts-ignore
import { RequestPremiumCheckIn } from '../model';
// @ts-ignore
import { ResponseDto } from '../model';
// @ts-ignore
import { SafarnamaSuccessfulReserve } from '../model';
// @ts-ignore
import { SimilarBillResponse } from '../model';
// @ts-ignore
import { StandardEcommerceBillResponse } from '../model';
// @ts-ignore
import { TicketFilesResponse } from '../model';
// @ts-ignore
import { TicketProviderResponse } from '../model';
// @ts-ignore
import { TravelersHistoryResponse } from '../model';
// @ts-ignore
import { TripSearchMode } from '../model';
// @ts-ignore
import { UpdateCommentTargetRequestDto } from '../model';
// @ts-ignore
import { UserBillsRequest } from '../model';
// @ts-ignore
import { UserBuySummary } from '../model';
// @ts-ignore
import { UserPurchaseResponse } from '../model';
/**
 * BillsApiApiAdminBillsBillCodeAssignUserMobilePut - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {string} mobile 
 * @param {boolean} [ignoreRateException] 
 * @param {boolean} [creditPayment] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsBillCodeAssignUserMobilePutAxiosParamCreator (billCode: string, mobile: string, ignoreRateException?: boolean, creditPayment?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAdminBillsBillCodeAssignUserMobilePut', 'billCode', billCode)
    // verify required parameter 'mobile' is not null or undefined
    assertParamExists('apiAdminBillsBillCodeAssignUserMobilePut', 'mobile', mobile)
    const localVarPath = `/api/admin/Bills/{billCode}/assign-user/{mobile}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)))
        .replace(`{${"mobile"}}`, encodeURIComponent(String(mobile)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (ignoreRateException !== undefined) {
        localVarQueryParameter['ignoreRateException'] = ignoreRateException;
    }

    if (creditPayment !== undefined) {
        localVarQueryParameter['creditPayment'] = creditPayment;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsBillCodeCouponPost - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {string} coupon 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsBillCodeCouponPostAxiosParamCreator (billCode: string, coupon: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAdminBillsBillCodeCouponPost', 'billCode', billCode)
    // verify required parameter 'coupon' is not null or undefined
    assertParamExists('apiAdminBillsBillCodeCouponPost', 'coupon', coupon)
    const localVarPath = `/api/admin/Bills/{billCode}/{coupon}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)))
        .replace(`{${"coupon"}}`, encodeURIComponent(String(coupon)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsBillCodePersonPersonIdPut - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {number} personId 
 * @param {EditPersonRequest} [editPersonRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsBillCodePersonPersonIdPutAxiosParamCreator (billCode: string, personId: number, editPersonRequest?: EditPersonRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAdminBillsBillCodePersonPersonIdPut', 'billCode', billCode)
    // verify required parameter 'personId' is not null or undefined
    assertParamExists('apiAdminBillsBillCodePersonPersonIdPut', 'personId', personId)
    const localVarPath = `/api/admin/Bills/{billCode}/Person/{personId}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)))
        .replace(`{${"personId"}}`, encodeURIComponent(String(personId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(editPersonRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsBillCodeSetIsoperatorFlagPut - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {number} [operatorId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsBillCodeSetIsoperatorFlagPutAxiosParamCreator (billCode: string, operatorId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAdminBillsBillCodeSetIsoperatorFlagPut', 'billCode', billCode)
    const localVarPath = `/api/admin/Bills/{billCode}/set-isoperator-flag`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (operatorId !== undefined) {
        localVarQueryParameter['operatorId'] = operatorId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsBillCodeUnAssignUserPut - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsBillCodeUnAssignUserPutAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAdminBillsBillCodeUnAssignUserPut', 'billCode', billCode)
    const localVarPath = `/api/admin/Bills/{billCode}/UnAssign-user`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsBillIdCommentPost - axios parameter creator
 * 
 * @summary send comment to bills with another services
 * @param {number} billId 
 * @param {string} [body] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsBillIdCommentPostAxiosParamCreator (billId: number, body?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billId' is not null or undefined
    assertParamExists('apiAdminBillsBillIdCommentPost', 'billId', billId)
    const localVarPath = `/api/admin/Bills/{billId}/Comment`
        .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsBulkGet - axios parameter creator
 * 
 * @summary Receives a list of ids or codes or both and returns bills
 * @param {Array<number>} [billIds] 
 * @param {Array<string>} [billCodes] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsBulkGetAxiosParamCreator (billIds?: Array<number>, billCodes?: Array<string>, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/admin/Bills/bulk`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (billIds) {
        localVarQueryParameter['BillIds'] = billIds;
    }

    if (billCodes) {
        localVarQueryParameter['BillCodes'] = billCodes;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsBulkSummaryGet - axios parameter creator
 * 
 * @param {Array<number>} [billIds] 
 * @param {Array<string>} [billCodes] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsBulkSummaryGetAxiosParamCreator (billIds?: Array<number>, billCodes?: Array<string>, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/admin/Bills/bulk/summary`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (billIds) {
        localVarQueryParameter['BillIds'] = billIds;
    }

    if (billCodes) {
        localVarQueryParameter['BillCodes'] = billCodes;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsByIdIdSetIsoperatorFlagPut - axios parameter creator
 * 
 * @param {number} id 
 * @param {number} [operatorId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsByIdIdSetIsoperatorFlagPutAxiosParamCreator (id: number, operatorId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiAdminBillsByIdIdSetIsoperatorFlagPut', 'id', id)
    const localVarPath = `/api/admin/Bills/byId/{id}/set-isoperator-flag`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (operatorId !== undefined) {
        localVarQueryParameter['operatorId'] = operatorId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsCancelBeforeReservePost - axios parameter creator
 * 
 * @summary cancel bill before reserve
 * @param {BillCancelBeforeReserveRequest} [billCancelBeforeReserveRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsCancelBeforeReservePostAxiosParamCreator (billCancelBeforeReserveRequest?: BillCancelBeforeReserveRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/admin/Bills/CancelBeforeReserve`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(billCancelBeforeReserveRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsCityMappingsGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsCityMappingsGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/admin/Bills/city-mappings`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsGetUserBuySummaryMobileGet - axios parameter creator
 * 
 * @param {string} mobile 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsGetUserBuySummaryMobileGetAxiosParamCreator (mobile: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'mobile' is not null or undefined
    assertParamExists('apiAdminBillsGetUserBuySummaryMobileGet', 'mobile', mobile)
    const localVarPath = `/api/admin/Bills/GetUserBuySummary/{mobile}`
        .replace(`{${"mobile"}}`, encodeURIComponent(String(mobile)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsMobileGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsMobileGetAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAdminBillsMobileGet', 'billCode', billCode)
    const localVarPath = `/api/admin/Bills/mobile`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (billCode !== undefined) {
        localVarQueryParameter['billCode'] = billCode;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsPaymentForceCancelPatch - axios parameter creator
 * 
 * @summary force cancellation payment
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsPaymentForceCancelPatchAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAdminBillsPaymentForceCancelPatch', 'billCode', billCode)
    const localVarPath = `/api/admin/Bills/PaymentForceCancel`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (billCode !== undefined) {
        localVarQueryParameter['billCode'] = billCode;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsPeopleBillCodeGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsPeopleBillCodeGetAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAdminBillsPeopleBillCodeGet', 'billCode', billCode)
    const localVarPath = `/api/admin/Bills/People/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsSetBuyAttributesBillCodePost - axios parameter creator
 * 
 * @summary Set buy attributes with finalizer service
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsSetBuyAttributesBillCodePostAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAdminBillsSetBuyAttributesBillCodePost', 'billCode', billCode)
    const localVarPath = `/api/admin/Bills/SetBuyAttributes/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsSuggestedServiceBillCodePut - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {EditBillSuggestedService} [editBillSuggestedService] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsSuggestedServiceBillCodePutAxiosParamCreator (billCode: string, editBillSuggestedService?: EditBillSuggestedService, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAdminBillsSuggestedServiceBillCodePut', 'billCode', billCode)
    const localVarPath = `/api/admin/Bills/SuggestedService/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(editBillSuggestedService, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsTicketProvidersGet - axios parameter creator
 * 
 * @param {string} [providerType] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsTicketProvidersGetAxiosParamCreator (providerType?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/admin/Bills/TicketProviders`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (providerType !== undefined) {
        localVarQueryParameter['providerType'] = providerType;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsTicketsGet - axios parameter creator
 * 
 * @param {string} [billCode] 
 * @param {number} [billId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsTicketsGetAxiosParamCreator (billCode?: string, billId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/admin/Bills/Tickets`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (billCode !== undefined) {
        localVarQueryParameter['billCode'] = billCode;
    }

    if (billId !== undefined) {
        localVarQueryParameter['billId'] = billId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsToggleLockPut - axios parameter creator
 * 
 * @param {string} [billCode] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsToggleLockPutAxiosParamCreator (billCode?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/admin/Bills/toggle-lock`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (billCode !== undefined) {
        localVarQueryParameter['billCode'] = billCode;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsUUIDCapmainBillCodeGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {string} [source] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsUUIDCapmainBillCodeGetAxiosParamCreator (billCode: string, source?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAdminBillsUUIDCapmainBillCodeGet', 'billCode', billCode)
    const localVarPath = `/api/admin/Bills/UUIDCapmain/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (source !== undefined) {
        localVarQueryParameter['source'] = source;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsUnSuccessfulBuyPost - axios parameter creator
 * 
 * @summary UnSuccessfulBuy reserve
 * @param {BillUnSuccessfulBuyReserveRequest} [billUnSuccessfulBuyReserveRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsUnSuccessfulBuyPostAxiosParamCreator (billUnSuccessfulBuyReserveRequest?: BillUnSuccessfulBuyReserveRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/admin/Bills/UnSuccessfulBuy`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(billUnSuccessfulBuyReserveRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsUpdateBillServiceAssociationBillcodePut - axios parameter creator
 * 
 * @summary Update Bill ServiceAssociations
 * @param {string} billCode 
 * @param {Array<BillAssociationRequest>} [billAssociationRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsUpdateBillServiceAssociationBillcodePutAxiosParamCreator (billCode: string, billAssociationRequest?: Array<BillAssociationRequest>, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAdminBillsUpdateBillServiceAssociationBillcodePut', 'billCode', billCode)
    const localVarPath = `/api/admin/Bills/UpdateBillServiceAssociation/{billcode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(billAssociationRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiAdminBillsUserIdBulkAssignToUserMobilePut - axios parameter creator
 * 
 * @param {number} userId 
 * @param {string} mobile 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiAdminBillsUserIdBulkAssignToUserMobilePutAxiosParamCreator (userId: number, mobile: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'userId' is not null or undefined
    assertParamExists('apiAdminBillsUserIdBulkAssignToUserMobilePut', 'userId', userId)
    // verify required parameter 'mobile' is not null or undefined
    assertParamExists('apiAdminBillsUserIdBulkAssignToUserMobilePut', 'mobile', mobile)
    const localVarPath = `/api/admin/Bills/{userId}/bulk-assign-to-user/{mobile}`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
        .replace(`{${"mobile"}}`, encodeURIComponent(String(mobile)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsAddPremiumCheckInPost - axios parameter creator
 * 
 * @param {RequestPremiumCheckIn} [requestPremiumCheckIn] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsAddPremiumCheckInPostAxiosParamCreator (requestPremiumCheckIn?: RequestPremiumCheckIn, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Bills/AddPremiumCheckIn`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(requestPremiumCheckIn, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsBillCodeAnalyticsAllGet - axios parameter creator
 * 
 * @summary Returns analytic parameters related to the bill with all providers
 * @param {string} billCode bill code
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsBillCodeAnalyticsAllGetAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsBillCodeAnalyticsAllGet', 'billCode', billCode)
    const localVarPath = `/api/Bills/{billCode}/analytics/all`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsBillCodeAnalyticsGet - axios parameter creator
 * 
 * @summary Returns analytic parameters related to the bill
 * @param {string} billCode bill code
 * @param {AnalyticProviders} [provider] bill code
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsBillCodeAnalyticsGetAxiosParamCreator (billCode: string, provider?: AnalyticProviders, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsBillCodeAnalyticsGet', 'billCode', billCode)
    const localVarPath = `/api/Bills/{billCode}/analytics`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (provider !== undefined) {
        localVarQueryParameter['provider'] = provider;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsBillCodeAssignUserPut - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {string} xPlayerID 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsBillCodeAssignUserPutAxiosParamCreator (billCode: string, xPlayerID: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsBillCodeAssignUserPut', 'billCode', billCode)
    // verify required parameter 'xPlayerID' is not null or undefined
    assertParamExists('apiBillsBillCodeAssignUserPut', 'xPlayerID', xPlayerID)
    const localVarPath = `/api/Bills/{billCode}/assign-user`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (xPlayerID != null) {
        localVarHeaderParameter['X-PlayerID'] = String(xPlayerID);
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsBillCodeCheckBillCaptchaGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {string} [captcha] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsBillCodeCheckBillCaptchaGetAxiosParamCreator (billCode: string, captcha?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsBillCodeCheckBillCaptchaGet', 'billCode', billCode)
    const localVarPath = `/api/Bills/{billCode}/CheckBillCaptcha`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (captcha !== undefined) {
        localVarQueryParameter['captcha'] = captcha;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsBillCodeCouponsCouponPut - axios parameter creator
 * 
 * @param {string} coupon 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsBillCodeCouponsCouponPutAxiosParamCreator (coupon: string, billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'coupon' is not null or undefined
    assertParamExists('apiBillsBillCodeCouponsCouponPut', 'coupon', coupon)
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsBillCodeCouponsCouponPut', 'billCode', billCode)
    const localVarPath = `/api/Bills/{billCode}/coupons/{coupon}`
        .replace(`{${"coupon"}}`, encodeURIComponent(String(coupon)))
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsBillCodeEnterGatewayGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {boolean} [useCredit] 
 * @param {boolean} [fallback] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsBillCodeEnterGatewayGetAxiosParamCreator (billCode: string, useCredit?: boolean, fallback?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsBillCodeEnterGatewayGet', 'billCode', billCode)
    const localVarPath = `/api/Bills/{billCode}/EnterGateway`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (useCredit !== undefined) {
        localVarQueryParameter['useCredit'] = useCredit;
    }

    if (fallback !== undefined) {
        localVarQueryParameter['fallback'] = fallback;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsBillCodeFullRefundGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {number} [billId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsBillCodeFullRefundGetAxiosParamCreator (billCode: string, billId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsBillCodeFullRefundGet', 'billCode', billCode)
    const localVarPath = `/api/Bills/{billCode}/full-refund`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (billId !== undefined) {
        localVarQueryParameter['billId'] = billId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsBillCodeGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {string} [mobile] 
 * @param {string} [mac] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsBillCodeGetAxiosParamCreator (billCode: string, mobile?: string, mac?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsBillCodeGet', 'billCode', billCode)
    const localVarPath = `/api/Bills/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (mobile !== undefined) {
        localVarQueryParameter['mobile'] = mobile;
    }

    if (mac !== undefined) {
        localVarQueryParameter['mac'] = mac;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsBillCodeMarkAsPaidByOperatorPost - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsBillCodeMarkAsPaidByOperatorPostAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsBillCodeMarkAsPaidByOperatorPost', 'billCode', billCode)
    const localVarPath = `/api/Bills/{billCode}/markAsPaidByOperator`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsBillCodeMarkAsPaidPost - axios parameter creator
 * 
 * @summary change bill status by its billCode
 * @param {string} billCode bill code
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsBillCodeMarkAsPaidPostAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsBillCodeMarkAsPaidPost', 'billCode', billCode)
    const localVarPath = `/api/Bills/{billCode}/markAsPaid`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsBillCodePeoplePut - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {Array<number>} [requestBody] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsBillCodePeoplePutAxiosParamCreator (billCode: string, requestBody?: Array<number>, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsBillCodePeoplePut', 'billCode', billCode)
    const localVarPath = `/api/Bills/{billCode}/people`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsBillCodePut - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {string} [xPlayerID] 
 * @param {string} [userAgent] 
 * @param {AddBillRequest} [addBillRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsBillCodePutAxiosParamCreator (billCode: string, xPlayerID?: string, userAgent?: string, addBillRequest?: AddBillRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsBillCodePut', 'billCode', billCode)
    const localVarPath = `/api/Bills/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (xPlayerID != null) {
        localVarHeaderParameter['X-PlayerID'] = String(xPlayerID);
    }

    if (userAgent != null) {
        localVarHeaderParameter['User-Agent'] = String(userAgent);
    }



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(addBillRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsBillCodeRecentSimilarBillsGet - axios parameter creator
 * 
 * @summary Returns all bill ids of passengers with national codes and passport numbers within 2 days ago
 * @param {string} billCode The bill code
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsBillCodeRecentSimilarBillsGetAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsBillCodeRecentSimilarBillsGet', 'billCode', billCode)
    const localVarPath = `/api/Bills/{billCode}/RecentSimilarBills`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsBillCodeSimilarBillsGet - axios parameter creator
 * 
 * @summary Fetches all similar bills to the specified bill, including its reserve types
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsBillCodeSimilarBillsGetAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsBillCodeSimilarBillsGet', 'billCode', billCode)
    const localVarPath = `/api/Bills/{billCode}/SimilarBills`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsBillCodeStatusStatusPost - axios parameter creator
 * 
 * @summary change bill status by its billCode
 * @param {string} billCode bill code
 * @param {BillStatus} status desired status
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsBillCodeStatusStatusPostAxiosParamCreator (billCode: string, status: BillStatus, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsBillCodeStatusStatusPost', 'billCode', billCode)
    // verify required parameter 'status' is not null or undefined
    assertParamExists('apiBillsBillCodeStatusStatusPost', 'status', status)
    const localVarPath = `/api/Bills/{billCode}/status/{status}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)))
        .replace(`{${"status"}}`, encodeURIComponent(String(status)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsByIdBillIdGet - axios parameter creator
 * 
 * @param {number} billId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsByIdBillIdGetAxiosParamCreator (billId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billId' is not null or undefined
    assertParamExists('apiBillsByIdBillIdGet', 'billId', billId)
    const localVarPath = `/api/Bills/ById/{billId}`
        .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsByIdIdStatusStatusPost - axios parameter creator
 * 
 * @summary change bill status by its identifier
 * @param {number} id bill id
 * @param {BillStatus} status desired status
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsByIdIdStatusStatusPostAxiosParamCreator (id: number, status: BillStatus, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiBillsByIdIdStatusStatusPost', 'id', id)
    // verify required parameter 'status' is not null or undefined
    assertParamExists('apiBillsByIdIdStatusStatusPost', 'status', status)
    const localVarPath = `/api/Bills/ById/{Id}/status/{status}`
        .replace(`{${"Id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"status"}}`, encodeURIComponent(String(status)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsGetUserBillsPost - axios parameter creator
 * 
 * @param {UserBillsRequest} [userBillsRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsGetUserBillsPostAxiosParamCreator (userBillsRequest?: UserBillsRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Bills/GetUserBills`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(userBillsRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsIdPatch - axios parameter creator
 * 
 * @summary change a bill\'s email if not paid
 * @param {number} id 
 * @param {string} email 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsIdPatchAxiosParamCreator (id: number, email: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiBillsIdPatch', 'id', id)
    // verify required parameter 'email' is not null or undefined
    assertParamExists('apiBillsIdPatch', 'email', email)
    const localVarPath = `/api/Bills/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (email !== undefined) {
        localVarQueryParameter['email'] = email;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsLinkBillsOriginalBillCodeMappedBillCodePost - axios parameter creator
 * 
 * @param {string} originalBillCode 
 * @param {string} mappedBillCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsLinkBillsOriginalBillCodeMappedBillCodePostAxiosParamCreator (originalBillCode: string, mappedBillCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'originalBillCode' is not null or undefined
    assertParamExists('apiBillsLinkBillsOriginalBillCodeMappedBillCodePost', 'originalBillCode', originalBillCode)
    // verify required parameter 'mappedBillCode' is not null or undefined
    assertParamExists('apiBillsLinkBillsOriginalBillCodeMappedBillCodePost', 'mappedBillCode', mappedBillCode)
    const localVarPath = `/api/Bills/LinkBills/{originalBillCode}/{mappedBillCode}`
        .replace(`{${"originalBillCode"}}`, encodeURIComponent(String(originalBillCode)))
        .replace(`{${"mappedBillCode"}}`, encodeURIComponent(String(mappedBillCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsPost - axios parameter creator
 * 
 * @param {string} [xPlayerID] 
 * @param {string} [userAgent] 
 * @param {AddBillRequest} [addBillRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsPostAxiosParamCreator (xPlayerID?: string, userAgent?: string, addBillRequest?: AddBillRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Bills`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (xPlayerID != null) {
        localVarHeaderParameter['X-PlayerID'] = String(xPlayerID);
    }

    if (userAgent != null) {
        localVarHeaderParameter['User-Agent'] = String(userAgent);
    }



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(addBillRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsReAssignUserBillCodePatch - axios parameter creator
 * 
 * @summary reassign the user of the bill by organizer (ASK kouhestani for more details)
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsReAssignUserBillCodePatchAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsReAssignUserBillCodePatch', 'billCode', billCode)
    const localVarPath = `/api/Bills/ReAssignUser/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsStandardEcommerceBillCodeGet - axios parameter creator
 * 
 * @param {string} mac 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsStandardEcommerceBillCodeGetAxiosParamCreator (mac: string, billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'mac' is not null or undefined
    assertParamExists('apiBillsStandardEcommerceBillCodeGet', 'mac', mac)
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsStandardEcommerceBillCodeGet', 'billCode', billCode)
    const localVarPath = `/api/Bills/StandardEcommerce/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (mac !== undefined) {
        localVarQueryParameter['mac'] = mac;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsSuggestedServiceBillCodePost - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {boolean} [cancellOtherSuggestedServices] 
 * @param {Array<AddBillSuggestedServiceRequest>} [addBillSuggestedServiceRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsSuggestedServiceBillCodePostAxiosParamCreator (billCode: string, cancellOtherSuggestedServices?: boolean, addBillSuggestedServiceRequest?: Array<AddBillSuggestedServiceRequest>, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsSuggestedServiceBillCodePost', 'billCode', billCode)
    const localVarPath = `/api/Bills/SuggestedService/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (cancellOtherSuggestedServices !== undefined) {
        localVarQueryParameter['cancellOtherSuggestedServices'] = cancellOtherSuggestedServices;
    }



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(addBillSuggestedServiceRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsTicketFilesGet - axios parameter creator
 * 
 * @summary get all tickets
 * @param {string} [startDate] 
 * @param {string} [endDate] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsTicketFilesGetAxiosParamCreator (startDate?: string, endDate?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Bills/TicketFiles`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (startDate !== undefined) {
        localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
            (startDate as any).toISOString() :
            startDate;
    }

    if (endDate !== undefined) {
        localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
            (endDate as any).toISOString() :
            endDate;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsTripCalendarGet - axios parameter creator
 * 
 * @param {string} [xPlayerId] 
 * @param {string} [startTime] 
 * @param {string} [endTime] 
 * @param {Array<TripSearchMode>} [tripSearchModes] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsTripCalendarGetAxiosParamCreator (xPlayerId?: string, startTime?: string, endTime?: string, tripSearchModes?: Array<TripSearchMode>, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Bills/trip-calendar`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (startTime !== undefined) {
        localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
            (startTime as any).toISOString() :
            startTime;
    }

    if (endTime !== undefined) {
        localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
            (endTime as any).toISOString() :
            endTime;
    }

    if (tripSearchModes) {
        localVarQueryParameter['tripSearchModes'] = tripSearchModes;
    }

    if (xPlayerId != null) {
        localVarHeaderParameter['X-Player-Id'] = String(xPlayerId);
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsTripReasonBillCodePatch - axios parameter creator
 * 
 * @summary Change reason of bill
 * @param {string} billCode 
 * @param {ChangeTripReasonRequest} [changeTripReasonRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsTripReasonBillCodePatchAxiosParamCreator (billCode: string, changeTripReasonRequest?: ChangeTripReasonRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsTripReasonBillCodePatch', 'billCode', billCode)
    const localVarPath = `/api/Bills/TripReason/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(changeTripReasonRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiBillsUserHasPurchaseGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiBillsUserHasPurchaseGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Bills/UserHasPurchase`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiReservesSafarnamaGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiReservesSafarnamaGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Reserves/Safarnama`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiApiSystemBillsRevenueBillCodeGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiApiSystemBillsRevenueBillCodeGetAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiSystemBillsRevenueBillCodeGet', 'billCode', billCode)
    const localVarPath = `/api/system/Bills/revenue/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiCommentPost - axios parameter creator
 * 
 * @summary Adds a comment with specifying all fields (just to be used with legacy services that do not have any alternative)
 * @param {AddCommentRequest} [addCommentRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiCommentPostAxiosParamCreator (addCommentRequest?: AddCommentRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/Comment`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(addCommentRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillsApiUpdateCommentTargetPost - axios parameter creator
 * 
 * @param {UpdateCommentTargetRequestDto} [updateCommentTargetRequestDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillsApiUpdateCommentTargetPostAxiosParamCreator (updateCommentTargetRequestDto?: UpdateCommentTargetRequestDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/UpdateCommentTarget`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(updateCommentTargetRequestDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiAdminBillsBillCodeAssignUserMobilePut operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsBillCodeAssignUserMobilePutRequest
 */
export interface BillsApiApiAdminBillsBillCodeAssignUserMobilePutRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsBillCodeAssignUserMobilePut
     */
    readonly billCode: string

    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsBillCodeAssignUserMobilePut
     */
    readonly mobile: string

    /**
     * 
     * @type {boolean}
     * @memberof BillsApiApiAdminBillsBillCodeAssignUserMobilePut
     */
    readonly ignoreRateException?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof BillsApiApiAdminBillsBillCodeAssignUserMobilePut
     */
    readonly creditPayment?: boolean
}

/**
 * Request parameters for apiAdminBillsBillCodeCouponPost operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsBillCodeCouponPostRequest
 */
export interface BillsApiApiAdminBillsBillCodeCouponPostRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsBillCodeCouponPost
     */
    readonly billCode: string

    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsBillCodeCouponPost
     */
    readonly coupon: string
}

/**
 * Request parameters for apiAdminBillsBillCodePersonPersonIdPut operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsBillCodePersonPersonIdPutRequest
 */
export interface BillsApiApiAdminBillsBillCodePersonPersonIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsBillCodePersonPersonIdPut
     */
    readonly billCode: string

    /**
     * 
     * @type {number}
     * @memberof BillsApiApiAdminBillsBillCodePersonPersonIdPut
     */
    readonly personId: number

    /**
     * 
     * @type {EditPersonRequest}
     * @memberof BillsApiApiAdminBillsBillCodePersonPersonIdPut
     */
    readonly editPersonRequest?: EditPersonRequest
}

/**
 * Request parameters for apiAdminBillsBillCodeSetIsoperatorFlagPut operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsBillCodeSetIsoperatorFlagPutRequest
 */
export interface BillsApiApiAdminBillsBillCodeSetIsoperatorFlagPutRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsBillCodeSetIsoperatorFlagPut
     */
    readonly billCode: string

    /**
     * 
     * @type {number}
     * @memberof BillsApiApiAdminBillsBillCodeSetIsoperatorFlagPut
     */
    readonly operatorId?: number
}

/**
 * Request parameters for apiAdminBillsBillCodeUnAssignUserPut operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsBillCodeUnAssignUserPutRequest
 */
export interface BillsApiApiAdminBillsBillCodeUnAssignUserPutRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsBillCodeUnAssignUserPut
     */
    readonly billCode: string
}

/**
 * Request parameters for apiAdminBillsBillIdCommentPost operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsBillIdCommentPostRequest
 */
export interface BillsApiApiAdminBillsBillIdCommentPostRequest {
    /**
     * 
     * @type {number}
     * @memberof BillsApiApiAdminBillsBillIdCommentPost
     */
    readonly billId: number

    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsBillIdCommentPost
     */
    readonly body?: string
}

/**
 * Request parameters for apiAdminBillsBulkGet operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsBulkGetRequest
 */
export interface BillsApiApiAdminBillsBulkGetRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof BillsApiApiAdminBillsBulkGet
     */
    readonly billIds?: Array<number>

    /**
     * 
     * @type {Array<string>}
     * @memberof BillsApiApiAdminBillsBulkGet
     */
    readonly billCodes?: Array<string>
}

/**
 * Request parameters for apiAdminBillsBulkSummaryGet operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsBulkSummaryGetRequest
 */
export interface BillsApiApiAdminBillsBulkSummaryGetRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof BillsApiApiAdminBillsBulkSummaryGet
     */
    readonly billIds?: Array<number>

    /**
     * 
     * @type {Array<string>}
     * @memberof BillsApiApiAdminBillsBulkSummaryGet
     */
    readonly billCodes?: Array<string>
}

/**
 * Request parameters for apiAdminBillsByIdIdSetIsoperatorFlagPut operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsByIdIdSetIsoperatorFlagPutRequest
 */
export interface BillsApiApiAdminBillsByIdIdSetIsoperatorFlagPutRequest {
    /**
     * 
     * @type {number}
     * @memberof BillsApiApiAdminBillsByIdIdSetIsoperatorFlagPut
     */
    readonly id: number

    /**
     * 
     * @type {number}
     * @memberof BillsApiApiAdminBillsByIdIdSetIsoperatorFlagPut
     */
    readonly operatorId?: number
}

/**
 * Request parameters for apiAdminBillsCancelBeforeReservePost operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsCancelBeforeReservePostRequest
 */
export interface BillsApiApiAdminBillsCancelBeforeReservePostRequest {
    /**
     * 
     * @type {BillCancelBeforeReserveRequest}
     * @memberof BillsApiApiAdminBillsCancelBeforeReservePost
     */
    readonly billCancelBeforeReserveRequest?: BillCancelBeforeReserveRequest
}

/**
 * Request parameters for apiAdminBillsGetUserBuySummaryMobileGet operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsGetUserBuySummaryMobileGetRequest
 */
export interface BillsApiApiAdminBillsGetUserBuySummaryMobileGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsGetUserBuySummaryMobileGet
     */
    readonly mobile: string
}

/**
 * Request parameters for apiAdminBillsMobileGet operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsMobileGetRequest
 */
export interface BillsApiApiAdminBillsMobileGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsMobileGet
     */
    readonly billCode: string
}

/**
 * Request parameters for apiAdminBillsPaymentForceCancelPatch operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsPaymentForceCancelPatchRequest
 */
export interface BillsApiApiAdminBillsPaymentForceCancelPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsPaymentForceCancelPatch
     */
    readonly billCode: string
}

/**
 * Request parameters for apiAdminBillsPeopleBillCodeGet operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsPeopleBillCodeGetRequest
 */
export interface BillsApiApiAdminBillsPeopleBillCodeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsPeopleBillCodeGet
     */
    readonly billCode: string
}

/**
 * Request parameters for apiAdminBillsSetBuyAttributesBillCodePost operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsSetBuyAttributesBillCodePostRequest
 */
export interface BillsApiApiAdminBillsSetBuyAttributesBillCodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsSetBuyAttributesBillCodePost
     */
    readonly billCode: string
}

/**
 * Request parameters for apiAdminBillsSuggestedServiceBillCodePut operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsSuggestedServiceBillCodePutRequest
 */
export interface BillsApiApiAdminBillsSuggestedServiceBillCodePutRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsSuggestedServiceBillCodePut
     */
    readonly billCode: string

    /**
     * 
     * @type {EditBillSuggestedService}
     * @memberof BillsApiApiAdminBillsSuggestedServiceBillCodePut
     */
    readonly editBillSuggestedService?: EditBillSuggestedService
}

/**
 * Request parameters for apiAdminBillsTicketProvidersGet operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsTicketProvidersGetRequest
 */
export interface BillsApiApiAdminBillsTicketProvidersGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsTicketProvidersGet
     */
    readonly providerType?: string
}

/**
 * Request parameters for apiAdminBillsTicketsGet operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsTicketsGetRequest
 */
export interface BillsApiApiAdminBillsTicketsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsTicketsGet
     */
    readonly billCode?: string

    /**
     * 
     * @type {number}
     * @memberof BillsApiApiAdminBillsTicketsGet
     */
    readonly billId?: number
}

/**
 * Request parameters for apiAdminBillsToggleLockPut operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsToggleLockPutRequest
 */
export interface BillsApiApiAdminBillsToggleLockPutRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsToggleLockPut
     */
    readonly billCode?: string
}

/**
 * Request parameters for apiAdminBillsUUIDCapmainBillCodeGet operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsUUIDCapmainBillCodeGetRequest
 */
export interface BillsApiApiAdminBillsUUIDCapmainBillCodeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsUUIDCapmainBillCodeGet
     */
    readonly billCode: string

    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsUUIDCapmainBillCodeGet
     */
    readonly source?: string
}

/**
 * Request parameters for apiAdminBillsUnSuccessfulBuyPost operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsUnSuccessfulBuyPostRequest
 */
export interface BillsApiApiAdminBillsUnSuccessfulBuyPostRequest {
    /**
     * 
     * @type {BillUnSuccessfulBuyReserveRequest}
     * @memberof BillsApiApiAdminBillsUnSuccessfulBuyPost
     */
    readonly billUnSuccessfulBuyReserveRequest?: BillUnSuccessfulBuyReserveRequest
}

/**
 * Request parameters for apiAdminBillsUpdateBillServiceAssociationBillcodePut operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsUpdateBillServiceAssociationBillcodePutRequest
 */
export interface BillsApiApiAdminBillsUpdateBillServiceAssociationBillcodePutRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsUpdateBillServiceAssociationBillcodePut
     */
    readonly billCode: string

    /**
     * 
     * @type {Array<BillAssociationRequest>}
     * @memberof BillsApiApiAdminBillsUpdateBillServiceAssociationBillcodePut
     */
    readonly billAssociationRequest?: Array<BillAssociationRequest>
}

/**
 * Request parameters for apiAdminBillsUserIdBulkAssignToUserMobilePut operation in BillsApi.
 * @export
 * @interface BillsApiApiAdminBillsUserIdBulkAssignToUserMobilePutRequest
 */
export interface BillsApiApiAdminBillsUserIdBulkAssignToUserMobilePutRequest {
    /**
     * 
     * @type {number}
     * @memberof BillsApiApiAdminBillsUserIdBulkAssignToUserMobilePut
     */
    readonly userId: number

    /**
     * 
     * @type {string}
     * @memberof BillsApiApiAdminBillsUserIdBulkAssignToUserMobilePut
     */
    readonly mobile: string
}

/**
 * Request parameters for apiBillsAddPremiumCheckInPost operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsAddPremiumCheckInPostRequest
 */
export interface BillsApiApiBillsAddPremiumCheckInPostRequest {
    /**
     * 
     * @type {RequestPremiumCheckIn}
     * @memberof BillsApiApiBillsAddPremiumCheckInPost
     */
    readonly requestPremiumCheckIn?: RequestPremiumCheckIn
}

/**
 * Request parameters for apiBillsBillCodeAnalyticsAllGet operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsBillCodeAnalyticsAllGetRequest
 */
export interface BillsApiApiBillsBillCodeAnalyticsAllGetRequest {
    /**
     * bill code
     * @type {string}
     * @memberof BillsApiApiBillsBillCodeAnalyticsAllGet
     */
    readonly billCode: string
}

/**
 * Request parameters for apiBillsBillCodeAnalyticsGet operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsBillCodeAnalyticsGetRequest
 */
export interface BillsApiApiBillsBillCodeAnalyticsGetRequest {
    /**
     * bill code
     * @type {string}
     * @memberof BillsApiApiBillsBillCodeAnalyticsGet
     */
    readonly billCode: string

    /**
     * bill code
     * @type {AnalyticProviders}
     * @memberof BillsApiApiBillsBillCodeAnalyticsGet
     */
    readonly provider?: AnalyticProviders
}

/**
 * Request parameters for apiBillsBillCodeAssignUserPut operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsBillCodeAssignUserPutRequest
 */
export interface BillsApiApiBillsBillCodeAssignUserPutRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsBillCodeAssignUserPut
     */
    readonly billCode: string

    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsBillCodeAssignUserPut
     */
    readonly xPlayerID: string
}

/**
 * Request parameters for apiBillsBillCodeCheckBillCaptchaGet operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsBillCodeCheckBillCaptchaGetRequest
 */
export interface BillsApiApiBillsBillCodeCheckBillCaptchaGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsBillCodeCheckBillCaptchaGet
     */
    readonly billCode: string

    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsBillCodeCheckBillCaptchaGet
     */
    readonly captcha?: string
}

/**
 * Request parameters for apiBillsBillCodeCouponsCouponPut operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsBillCodeCouponsCouponPutRequest
 */
export interface BillsApiApiBillsBillCodeCouponsCouponPutRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsBillCodeCouponsCouponPut
     */
    readonly coupon: string

    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsBillCodeCouponsCouponPut
     */
    readonly billCode: string
}

/**
 * Request parameters for apiBillsBillCodeEnterGatewayGet operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsBillCodeEnterGatewayGetRequest
 */
export interface BillsApiApiBillsBillCodeEnterGatewayGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsBillCodeEnterGatewayGet
     */
    readonly billCode: string

    /**
     * 
     * @type {boolean}
     * @memberof BillsApiApiBillsBillCodeEnterGatewayGet
     */
    readonly useCredit?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof BillsApiApiBillsBillCodeEnterGatewayGet
     */
    readonly fallback?: boolean
}

/**
 * Request parameters for apiBillsBillCodeFullRefundGet operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsBillCodeFullRefundGetRequest
 */
export interface BillsApiApiBillsBillCodeFullRefundGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsBillCodeFullRefundGet
     */
    readonly billCode: string

    /**
     * 
     * @type {number}
     * @memberof BillsApiApiBillsBillCodeFullRefundGet
     */
    readonly billId?: number
}

/**
 * Request parameters for apiBillsBillCodeGet operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsBillCodeGetRequest
 */
export interface BillsApiApiBillsBillCodeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsBillCodeGet
     */
    readonly billCode: string

    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsBillCodeGet
     */
    readonly mobile?: string

    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsBillCodeGet
     */
    readonly mac?: string
}

/**
 * Request parameters for apiBillsBillCodeMarkAsPaidByOperatorPost operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsBillCodeMarkAsPaidByOperatorPostRequest
 */
export interface BillsApiApiBillsBillCodeMarkAsPaidByOperatorPostRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsBillCodeMarkAsPaidByOperatorPost
     */
    readonly billCode: string
}

/**
 * Request parameters for apiBillsBillCodeMarkAsPaidPost operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsBillCodeMarkAsPaidPostRequest
 */
export interface BillsApiApiBillsBillCodeMarkAsPaidPostRequest {
    /**
     * bill code
     * @type {string}
     * @memberof BillsApiApiBillsBillCodeMarkAsPaidPost
     */
    readonly billCode: string
}

/**
 * Request parameters for apiBillsBillCodePeoplePut operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsBillCodePeoplePutRequest
 */
export interface BillsApiApiBillsBillCodePeoplePutRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsBillCodePeoplePut
     */
    readonly billCode: string

    /**
     * 
     * @type {Array<number>}
     * @memberof BillsApiApiBillsBillCodePeoplePut
     */
    readonly requestBody?: Array<number>
}

/**
 * Request parameters for apiBillsBillCodePut operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsBillCodePutRequest
 */
export interface BillsApiApiBillsBillCodePutRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsBillCodePut
     */
    readonly billCode: string

    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsBillCodePut
     */
    readonly xPlayerID?: string

    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsBillCodePut
     */
    readonly userAgent?: string

    /**
     * 
     * @type {AddBillRequest}
     * @memberof BillsApiApiBillsBillCodePut
     */
    readonly addBillRequest?: AddBillRequest
}

/**
 * Request parameters for apiBillsBillCodeRecentSimilarBillsGet operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsBillCodeRecentSimilarBillsGetRequest
 */
export interface BillsApiApiBillsBillCodeRecentSimilarBillsGetRequest {
    /**
     * The bill code
     * @type {string}
     * @memberof BillsApiApiBillsBillCodeRecentSimilarBillsGet
     */
    readonly billCode: string
}

/**
 * Request parameters for apiBillsBillCodeSimilarBillsGet operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsBillCodeSimilarBillsGetRequest
 */
export interface BillsApiApiBillsBillCodeSimilarBillsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsBillCodeSimilarBillsGet
     */
    readonly billCode: string
}

/**
 * Request parameters for apiBillsBillCodeStatusStatusPost operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsBillCodeStatusStatusPostRequest
 */
export interface BillsApiApiBillsBillCodeStatusStatusPostRequest {
    /**
     * bill code
     * @type {string}
     * @memberof BillsApiApiBillsBillCodeStatusStatusPost
     */
    readonly billCode: string

    /**
     * desired status
     * @type {BillStatus}
     * @memberof BillsApiApiBillsBillCodeStatusStatusPost
     */
    readonly status: BillStatus
}

/**
 * Request parameters for apiBillsByIdBillIdGet operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsByIdBillIdGetRequest
 */
export interface BillsApiApiBillsByIdBillIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof BillsApiApiBillsByIdBillIdGet
     */
    readonly billId: number
}

/**
 * Request parameters for apiBillsByIdIdStatusStatusPost operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsByIdIdStatusStatusPostRequest
 */
export interface BillsApiApiBillsByIdIdStatusStatusPostRequest {
    /**
     * bill id
     * @type {number}
     * @memberof BillsApiApiBillsByIdIdStatusStatusPost
     */
    readonly id: number

    /**
     * desired status
     * @type {BillStatus}
     * @memberof BillsApiApiBillsByIdIdStatusStatusPost
     */
    readonly status: BillStatus
}

/**
 * Request parameters for apiBillsGetUserBillsPost operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsGetUserBillsPostRequest
 */
export interface BillsApiApiBillsGetUserBillsPostRequest {
    /**
     * 
     * @type {UserBillsRequest}
     * @memberof BillsApiApiBillsGetUserBillsPost
     */
    readonly userBillsRequest?: UserBillsRequest
}

/**
 * Request parameters for apiBillsIdPatch operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsIdPatchRequest
 */
export interface BillsApiApiBillsIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof BillsApiApiBillsIdPatch
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsIdPatch
     */
    readonly email: string
}

/**
 * Request parameters for apiBillsLinkBillsOriginalBillCodeMappedBillCodePost operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsLinkBillsOriginalBillCodeMappedBillCodePostRequest
 */
export interface BillsApiApiBillsLinkBillsOriginalBillCodeMappedBillCodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsLinkBillsOriginalBillCodeMappedBillCodePost
     */
    readonly originalBillCode: string

    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsLinkBillsOriginalBillCodeMappedBillCodePost
     */
    readonly mappedBillCode: string
}

/**
 * Request parameters for apiBillsPost operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsPostRequest
 */
export interface BillsApiApiBillsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsPost
     */
    readonly xPlayerID?: string

    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsPost
     */
    readonly userAgent?: string

    /**
     * 
     * @type {AddBillRequest}
     * @memberof BillsApiApiBillsPost
     */
    readonly addBillRequest?: AddBillRequest
}

/**
 * Request parameters for apiBillsReAssignUserBillCodePatch operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsReAssignUserBillCodePatchRequest
 */
export interface BillsApiApiBillsReAssignUserBillCodePatchRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsReAssignUserBillCodePatch
     */
    readonly billCode: string
}

/**
 * Request parameters for apiBillsStandardEcommerceBillCodeGet operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsStandardEcommerceBillCodeGetRequest
 */
export interface BillsApiApiBillsStandardEcommerceBillCodeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsStandardEcommerceBillCodeGet
     */
    readonly mac: string

    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsStandardEcommerceBillCodeGet
     */
    readonly billCode: string
}

/**
 * Request parameters for apiBillsSuggestedServiceBillCodePost operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsSuggestedServiceBillCodePostRequest
 */
export interface BillsApiApiBillsSuggestedServiceBillCodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsSuggestedServiceBillCodePost
     */
    readonly billCode: string

    /**
     * 
     * @type {boolean}
     * @memberof BillsApiApiBillsSuggestedServiceBillCodePost
     */
    readonly cancellOtherSuggestedServices?: boolean

    /**
     * 
     * @type {Array<AddBillSuggestedServiceRequest>}
     * @memberof BillsApiApiBillsSuggestedServiceBillCodePost
     */
    readonly addBillSuggestedServiceRequest?: Array<AddBillSuggestedServiceRequest>
}

/**
 * Request parameters for apiBillsTicketFilesGet operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsTicketFilesGetRequest
 */
export interface BillsApiApiBillsTicketFilesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsTicketFilesGet
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsTicketFilesGet
     */
    readonly endDate?: string
}

/**
 * Request parameters for apiBillsTripCalendarGet operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsTripCalendarGetRequest
 */
export interface BillsApiApiBillsTripCalendarGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsTripCalendarGet
     */
    readonly xPlayerId?: string

    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsTripCalendarGet
     */
    readonly startTime?: string

    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsTripCalendarGet
     */
    readonly endTime?: string

    /**
     * 
     * @type {Array<TripSearchMode>}
     * @memberof BillsApiApiBillsTripCalendarGet
     */
    readonly tripSearchModes?: Array<TripSearchMode>
}

/**
 * Request parameters for apiBillsTripReasonBillCodePatch operation in BillsApi.
 * @export
 * @interface BillsApiApiBillsTripReasonBillCodePatchRequest
 */
export interface BillsApiApiBillsTripReasonBillCodePatchRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiBillsTripReasonBillCodePatch
     */
    readonly billCode: string

    /**
     * 
     * @type {ChangeTripReasonRequest}
     * @memberof BillsApiApiBillsTripReasonBillCodePatch
     */
    readonly changeTripReasonRequest?: ChangeTripReasonRequest
}

/**
 * Request parameters for apiSystemBillsRevenueBillCodeGet operation in BillsApi.
 * @export
 * @interface BillsApiApiSystemBillsRevenueBillCodeGetRequest
 */
export interface BillsApiApiSystemBillsRevenueBillCodeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BillsApiApiSystemBillsRevenueBillCodeGet
     */
    readonly billCode: string
}

/**
 * Request parameters for commentPost operation in BillsApi.
 * @export
 * @interface BillsApiCommentPostRequest
 */
export interface BillsApiCommentPostRequest {
    /**
     * 
     * @type {AddCommentRequest}
     * @memberof BillsApiCommentPost
     */
    readonly addCommentRequest?: AddCommentRequest
}

/**
 * Request parameters for updateCommentTargetPost operation in BillsApi.
 * @export
 * @interface BillsApiUpdateCommentTargetPostRequest
 */
export interface BillsApiUpdateCommentTargetPostRequest {
    /**
     * 
     * @type {UpdateCommentTargetRequestDto}
     * @memberof BillsApiUpdateCommentTargetPost
     */
    readonly updateCommentTargetRequestDto?: UpdateCommentTargetRequestDto
}

/**
* 
* @param {BillsApiApiAdminBillsBillCodeAssignUserMobilePutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsBillCodeAssignUserMobilePut(requestParameters: BillsApiApiAdminBillsBillCodeAssignUserMobilePutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsBillCodeAssignUserMobilePutAxiosParamCreator(requestParameters.billCode, requestParameters.mobile, requestParameters.ignoreRateException, requestParameters.creditPayment, options, configuration);
    const request: () => AxiosPromise<ResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiAdminBillsBillCodeCouponPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsBillCodeCouponPost(requestParameters: BillsApiApiAdminBillsBillCodeCouponPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsBillCodeCouponPostAxiosParamCreator(requestParameters.billCode, requestParameters.coupon, options, configuration);
    const request: () => AxiosPromise<boolean> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiAdminBillsBillCodePersonPersonIdPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsBillCodePersonPersonIdPut(requestParameters: BillsApiApiAdminBillsBillCodePersonPersonIdPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsBillCodePersonPersonIdPutAxiosParamCreator(requestParameters.billCode, requestParameters.personId, requestParameters.editPersonRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiAdminBillsBillCodeSetIsoperatorFlagPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsBillCodeSetIsoperatorFlagPut(requestParameters: BillsApiApiAdminBillsBillCodeSetIsoperatorFlagPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsBillCodeSetIsoperatorFlagPutAxiosParamCreator(requestParameters.billCode, requestParameters.operatorId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiAdminBillsBillCodeUnAssignUserPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsBillCodeUnAssignUserPut(requestParameters: BillsApiApiAdminBillsBillCodeUnAssignUserPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsBillCodeUnAssignUserPutAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary send comment to bills with another services
* @param {BillsApiApiAdminBillsBillIdCommentPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsBillIdCommentPost(requestParameters: BillsApiApiAdminBillsBillIdCommentPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsBillIdCommentPostAxiosParamCreator(requestParameters.billId, requestParameters.body, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Receives a list of ids or codes or both and returns bills
* @param {BillsApiApiAdminBillsBulkGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsBulkGet(requestParameters: BillsApiApiAdminBillsBulkGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsBulkGetAxiosParamCreator(requestParameters.billIds, requestParameters.billCodes, options, configuration);
    const request: () => AxiosPromise<Array<AdminBillResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiAdminBillsBulkSummaryGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsBulkSummaryGet(requestParameters: BillsApiApiAdminBillsBulkSummaryGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsBulkSummaryGetAxiosParamCreator(requestParameters.billIds, requestParameters.billCodes, options, configuration);
    const request: () => AxiosPromise<Array<BillResponseSummary>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiAdminBillsByIdIdSetIsoperatorFlagPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsByIdIdSetIsoperatorFlagPut(requestParameters: BillsApiApiAdminBillsByIdIdSetIsoperatorFlagPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsByIdIdSetIsoperatorFlagPutAxiosParamCreator(requestParameters.id, requestParameters.operatorId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary cancel bill before reserve
* @param {BillsApiApiAdminBillsCancelBeforeReservePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsCancelBeforeReservePost(requestParameters: BillsApiApiAdminBillsCancelBeforeReservePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsCancelBeforeReservePostAxiosParamCreator(requestParameters.billCancelBeforeReserveRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsCityMappingsGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsCityMappingsGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<AllCityMappingsResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiAdminBillsGetUserBuySummaryMobileGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsGetUserBuySummaryMobileGet(requestParameters: BillsApiApiAdminBillsGetUserBuySummaryMobileGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsGetUserBuySummaryMobileGetAxiosParamCreator(requestParameters.mobile, options, configuration);
    const request: () => AxiosPromise<UserBuySummary> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiAdminBillsMobileGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsMobileGet(requestParameters: BillsApiApiAdminBillsMobileGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsMobileGetAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<GetBillMobileResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary force cancellation payment
* @param {BillsApiApiAdminBillsPaymentForceCancelPatchRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsPaymentForceCancelPatch(requestParameters: BillsApiApiAdminBillsPaymentForceCancelPatchRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsPaymentForceCancelPatchAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiAdminBillsPeopleBillCodeGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsPeopleBillCodeGet(requestParameters: BillsApiApiAdminBillsPeopleBillCodeGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsPeopleBillCodeGetAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<Array<TravelersHistoryResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Set buy attributes with finalizer service
* @param {BillsApiApiAdminBillsSetBuyAttributesBillCodePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsSetBuyAttributesBillCodePost(requestParameters: BillsApiApiAdminBillsSetBuyAttributesBillCodePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsSetBuyAttributesBillCodePostAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<UserBuySummary> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiAdminBillsSuggestedServiceBillCodePutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsSuggestedServiceBillCodePut(requestParameters: BillsApiApiAdminBillsSuggestedServiceBillCodePutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsSuggestedServiceBillCodePutAxiosParamCreator(requestParameters.billCode, requestParameters.editBillSuggestedService, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiAdminBillsTicketProvidersGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsTicketProvidersGet(requestParameters: BillsApiApiAdminBillsTicketProvidersGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsTicketProvidersGetAxiosParamCreator(requestParameters.providerType, options, configuration);
    const request: () => AxiosPromise<Array<TicketProviderResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiAdminBillsTicketsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsTicketsGet(requestParameters: BillsApiApiAdminBillsTicketsGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsTicketsGetAxiosParamCreator(requestParameters.billCode, requestParameters.billId, options, configuration);
    const request: () => AxiosPromise<Array<AdminTicketResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiAdminBillsToggleLockPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsToggleLockPut(requestParameters: BillsApiApiAdminBillsToggleLockPutRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsToggleLockPutAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiAdminBillsUUIDCapmainBillCodeGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsUUIDCapmainBillCodeGet(requestParameters: BillsApiApiAdminBillsUUIDCapmainBillCodeGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsUUIDCapmainBillCodeGetAxiosParamCreator(requestParameters.billCode, requestParameters.source, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary UnSuccessfulBuy reserve
* @param {BillsApiApiAdminBillsUnSuccessfulBuyPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsUnSuccessfulBuyPost(requestParameters: BillsApiApiAdminBillsUnSuccessfulBuyPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsUnSuccessfulBuyPostAxiosParamCreator(requestParameters.billUnSuccessfulBuyReserveRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Update Bill ServiceAssociations
* @param {BillsApiApiAdminBillsUpdateBillServiceAssociationBillcodePutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsUpdateBillServiceAssociationBillcodePut(requestParameters: BillsApiApiAdminBillsUpdateBillServiceAssociationBillcodePutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsUpdateBillServiceAssociationBillcodePutAxiosParamCreator(requestParameters.billCode, requestParameters.billAssociationRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiAdminBillsUserIdBulkAssignToUserMobilePutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiAdminBillsUserIdBulkAssignToUserMobilePut(requestParameters: BillsApiApiAdminBillsUserIdBulkAssignToUserMobilePutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiAdminBillsUserIdBulkAssignToUserMobilePutAxiosParamCreator(requestParameters.userId, requestParameters.mobile, options, configuration);
    const request: () => AxiosPromise<ResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiBillsAddPremiumCheckInPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsAddPremiumCheckInPost(requestParameters: BillsApiApiBillsAddPremiumCheckInPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsAddPremiumCheckInPostAxiosParamCreator(requestParameters.requestPremiumCheckIn, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Returns analytic parameters related to the bill with all providers
* @param {BillsApiApiBillsBillCodeAnalyticsAllGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsBillCodeAnalyticsAllGet(requestParameters: BillsApiApiBillsBillCodeAnalyticsAllGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsBillCodeAnalyticsAllGetAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<AllProvidersBillAnalyticsResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Returns analytic parameters related to the bill
* @param {BillsApiApiBillsBillCodeAnalyticsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsBillCodeAnalyticsGet(requestParameters: BillsApiApiBillsBillCodeAnalyticsGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsBillCodeAnalyticsGetAxiosParamCreator(requestParameters.billCode, requestParameters.provider, options, configuration);
    const request: () => AxiosPromise<BillAnalyticsResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiBillsBillCodeAssignUserPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsBillCodeAssignUserPut(requestParameters: BillsApiApiBillsBillCodeAssignUserPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsBillCodeAssignUserPutAxiosParamCreator(requestParameters.billCode, requestParameters.xPlayerID, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiBillsBillCodeCheckBillCaptchaGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsBillCodeCheckBillCaptchaGet(requestParameters: BillsApiApiBillsBillCodeCheckBillCaptchaGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsBillCodeCheckBillCaptchaGetAxiosParamCreator(requestParameters.billCode, requestParameters.captcha, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiBillsBillCodeCouponsCouponPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsBillCodeCouponsCouponPut(requestParameters: BillsApiApiBillsBillCodeCouponsCouponPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsBillCodeCouponsCouponPutAxiosParamCreator(requestParameters.coupon, requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiBillsBillCodeEnterGatewayGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsBillCodeEnterGatewayGet(requestParameters: BillsApiApiBillsBillCodeEnterGatewayGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsBillCodeEnterGatewayGetAxiosParamCreator(requestParameters.billCode, requestParameters.useCredit, requestParameters.fallback, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiBillsBillCodeFullRefundGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsBillCodeFullRefundGet(requestParameters: BillsApiApiBillsBillCodeFullRefundGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsBillCodeFullRefundGetAxiosParamCreator(requestParameters.billCode, requestParameters.billId, options, configuration);
    const request: () => AxiosPromise<Array<FullRefundResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiBillsBillCodeGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsBillCodeGet(requestParameters: BillsApiApiBillsBillCodeGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsBillCodeGetAxiosParamCreator(requestParameters.billCode, requestParameters.mobile, requestParameters.mac, options, configuration);
    const request: () => AxiosPromise<BillResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiBillsBillCodeMarkAsPaidByOperatorPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsBillCodeMarkAsPaidByOperatorPost(requestParameters: BillsApiApiBillsBillCodeMarkAsPaidByOperatorPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsBillCodeMarkAsPaidByOperatorPostAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary change bill status by its billCode
* @param {BillsApiApiBillsBillCodeMarkAsPaidPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsBillCodeMarkAsPaidPost(requestParameters: BillsApiApiBillsBillCodeMarkAsPaidPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsBillCodeMarkAsPaidPostAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiBillsBillCodePeoplePutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsBillCodePeoplePut(requestParameters: BillsApiApiBillsBillCodePeoplePutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsBillCodePeoplePutAxiosParamCreator(requestParameters.billCode, requestParameters.requestBody, options, configuration);
    const request: () => AxiosPromise<AddBillResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiBillsBillCodePutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsBillCodePut(requestParameters: BillsApiApiBillsBillCodePutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsBillCodePutAxiosParamCreator(requestParameters.billCode, requestParameters.xPlayerID, requestParameters.userAgent, requestParameters.addBillRequest, options, configuration);
    const request: () => AxiosPromise<AddBillResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Returns all bill ids of passengers with national codes and passport numbers within 2 days ago
* @param {BillsApiApiBillsBillCodeRecentSimilarBillsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsBillCodeRecentSimilarBillsGet(requestParameters: BillsApiApiBillsBillCodeRecentSimilarBillsGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsBillCodeRecentSimilarBillsGetAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<RecentBillIdsOfPassengersResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Fetches all similar bills to the specified bill, including its reserve types
* @param {BillsApiApiBillsBillCodeSimilarBillsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsBillCodeSimilarBillsGet(requestParameters: BillsApiApiBillsBillCodeSimilarBillsGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsBillCodeSimilarBillsGetAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<SimilarBillResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary change bill status by its billCode
* @param {BillsApiApiBillsBillCodeStatusStatusPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsBillCodeStatusStatusPost(requestParameters: BillsApiApiBillsBillCodeStatusStatusPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsBillCodeStatusStatusPostAxiosParamCreator(requestParameters.billCode, requestParameters.status, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiBillsByIdBillIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsByIdBillIdGet(requestParameters: BillsApiApiBillsByIdBillIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsByIdBillIdGetAxiosParamCreator(requestParameters.billId, options, configuration);
    const request: () => AxiosPromise<BillResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary change bill status by its identifier
* @param {BillsApiApiBillsByIdIdStatusStatusPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsByIdIdStatusStatusPost(requestParameters: BillsApiApiBillsByIdIdStatusStatusPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsByIdIdStatusStatusPostAxiosParamCreator(requestParameters.id, requestParameters.status, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiBillsGetUserBillsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsGetUserBillsPost(requestParameters: BillsApiApiBillsGetUserBillsPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsGetUserBillsPostAxiosParamCreator(requestParameters.userBillsRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary change a bill\'s email if not paid
* @param {BillsApiApiBillsIdPatchRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsIdPatch(requestParameters: BillsApiApiBillsIdPatchRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsIdPatchAxiosParamCreator(requestParameters.id, requestParameters.email, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiBillsLinkBillsOriginalBillCodeMappedBillCodePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsLinkBillsOriginalBillCodeMappedBillCodePost(requestParameters: BillsApiApiBillsLinkBillsOriginalBillCodeMappedBillCodePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsLinkBillsOriginalBillCodeMappedBillCodePostAxiosParamCreator(requestParameters.originalBillCode, requestParameters.mappedBillCode, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiBillsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsPost(requestParameters: BillsApiApiBillsPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsPostAxiosParamCreator(requestParameters.xPlayerID, requestParameters.userAgent, requestParameters.addBillRequest, options, configuration);
    const request: () => AxiosPromise<AddBillResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary reassign the user of the bill by organizer (ASK kouhestani for more details)
* @param {BillsApiApiBillsReAssignUserBillCodePatchRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsReAssignUserBillCodePatch(requestParameters: BillsApiApiBillsReAssignUserBillCodePatchRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsReAssignUserBillCodePatchAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<string> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiBillsStandardEcommerceBillCodeGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsStandardEcommerceBillCodeGet(requestParameters: BillsApiApiBillsStandardEcommerceBillCodeGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsStandardEcommerceBillCodeGetAxiosParamCreator(requestParameters.mac, requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<StandardEcommerceBillResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiBillsSuggestedServiceBillCodePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsSuggestedServiceBillCodePost(requestParameters: BillsApiApiBillsSuggestedServiceBillCodePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsSuggestedServiceBillCodePostAxiosParamCreator(requestParameters.billCode, requestParameters.cancellOtherSuggestedServices, requestParameters.addBillSuggestedServiceRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary get all tickets
* @param {BillsApiApiBillsTicketFilesGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsTicketFilesGet(requestParameters: BillsApiApiBillsTicketFilesGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsTicketFilesGetAxiosParamCreator(requestParameters.startDate, requestParameters.endDate, options, configuration);
    const request: () => AxiosPromise<TicketFilesResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiBillsTripCalendarGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsTripCalendarGet(requestParameters: BillsApiApiBillsTripCalendarGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsTripCalendarGetAxiosParamCreator(requestParameters.xPlayerId, requestParameters.startTime, requestParameters.endTime, requestParameters.tripSearchModes, options, configuration);
    const request: () => AxiosPromise<BillListResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Change reason of bill
* @param {BillsApiApiBillsTripReasonBillCodePatchRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsTripReasonBillCodePatch(requestParameters: BillsApiApiBillsTripReasonBillCodePatchRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsTripReasonBillCodePatchAxiosParamCreator(requestParameters.billCode, requestParameters.changeTripReasonRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiBillsUserHasPurchaseGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiBillsUserHasPurchaseGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<UserPurchaseResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiReservesSafarnamaGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiReservesSafarnamaGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<SafarnamaSuccessfulReserve>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiApiSystemBillsRevenueBillCodeGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiApiSystemBillsRevenueBillCodeGet(requestParameters: BillsApiApiSystemBillsRevenueBillCodeGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiApiSystemBillsRevenueBillCodeGetAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<BillRevenueResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Adds a comment with specifying all fields (just to be used with legacy services that do not have any alternative)
* @param {BillsApiCommentPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiCommentPost(requestParameters: BillsApiCommentPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiCommentPostAxiosParamCreator(requestParameters.addCommentRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillsApiUpdateCommentTargetPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillsApiUpdateCommentTargetPost(requestParameters: BillsApiUpdateCommentTargetPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillsApiUpdateCommentTargetPostAxiosParamCreator(requestParameters.updateCommentTargetRequestDto, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
